import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, FileHeart } from 'lucide-react';
import ReferralStatusBadge from '@/modules/referral/components/ReferralStatusBadge';
import { IITH, SERIF } from '@/pages/landing/iithBrand';

/** Recent referral requests teaser. */
export default function PatientReferralTeaser({ items = [], primary = IITH.saffron }) {
  return (
    <section className="mb-10 rounded-3xl border border-[#D5DEE8] bg-white p-5 sm:p-6 shadow-sm" data-testid="patient-refs-teaser">
      <div className="flex flex-wrap items-center justify-between gap-2 mb-4">
        <div>
          <h2 className="text-lg font-bold text-[#071B34]" style={{ fontFamily: SERIF }}>Referral letters</h2>
          <p className="text-xs text-[#7A8B9C]">Campus doctor referrals to hospitals & specialists</p>
        </div>
        <Link to="/patient/referrals" className="text-xs font-semibold inline-flex items-center gap-1" style={{ color: primary }}>
          Track all <ArrowRight className="h-3.5 w-3.5" />
        </Link>
      </div>
      {items.length === 0 ? (
        <div className="flex flex-col sm:flex-row sm:items-center gap-3 rounded-2xl bg-gradient-to-br from-[#071B34] to-[#0C2744] p-5 text-white">
          <FileHeart className="h-8 w-8 text-[#C4A35A] shrink-0" />
          <div className="flex-1">
            <p className="font-semibold">Need care outside campus?</p>
            <p className="text-sm text-white/70 mt-1">Request an official referral letter from an enabled campus doctor.</p>
          </div>
          <Link
            to="/patient/referrals/new"
            className="inline-flex items-center justify-center rounded-full px-4 py-2 text-sm font-semibold text-[#071B34] bg-white"
          >
            Start request
          </Link>
        </div>
      ) : (
        <ul className="space-y-2">
          {items.slice(0, 4).map((r) => (
            <li key={r.id}>
              <Link
                to={`/patient/referrals/${r.id}`}
                className="flex flex-wrap items-center justify-between gap-2 rounded-xl border border-[#EEF2F7] px-3.5 py-3 hover:bg-[#F8FAFC]"
              >
                <div>
                  <p className="text-sm font-semibold text-[#071B34]">{r.request_number}</p>
                  <p className="text-[12px] text-[#5A6B7C]">
                    {r.seeking?.hospital_clinic} · {r.seeking?.specialisation}
                  </p>
                </div>
                <ReferralStatusBadge status={r.status} />
              </Link>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
